const riot = require('riot');

riot.tag2('module-sidebar', '<div class="f fclm fbw h-full w256 elevation-default-mid bg-white"> <div class="f fh flex-fixed h72 px24 bg-navy_30" if="{mode === &quot;admin&quot;}"><a class="text-white ts-ps-bold" href="/">Repro Incentive Operator Console</a></div> <div class="f fm flex-fixed h72 px24" if="{mode === &quot;app&quot;}"><a class="block w180 mr10" href="/"> <img class="s-full object-fit-contain" src="/images/logo.svg" alt=""></a></div> <div class="f fclm fbw h-full"> <div> <div class="mb8 mb0-last" each="{item in getMenus(&quot;top&quot;)}"> <div class="py12 px16 ts-ps hover-trigger hover-text-blue_70 cursor-pointer word-break-all {getMenuClass(item)}" if="{!item.is_select}" onclick="{item.event}">{item.label}</div> <div class="f fm fbw py18 px16 hover-trigger cursor-pointer border-top border-bottom border-gray_10 {getMenuClass(item)}" if="{item.is_select}" onclick="{item.event}"> <div class="ts-ps word-break-all line-clamp-1 hover-text-blue_70">{item.label}</div><i class="icon-cheveron-down flex-fixed fs24 text-gray_30 hover-text-blue_70"></i> </div> </div> </div> <div> <div class="mb8 mb0-last" each="{item in getMenus(&quot;bottom&quot;)}"> <div class="py12 px16 cursor-pointer {getMenuClass(item)}" if="{!item.is_select}" onclick="{item.event}"> <div class="ts-ps hover-trigger hover-text-blue_70 word-break-all">{item.label}</div> <div class="pt8" if="{item.show_role}"> <div class="f fh w200 h20 rounded-full bg-navy_30 text-white ts-pxs-bold">Repro Incentive Operator</div> </div> </div> <div class="f fm fbw py18 px16 hover-trigger cursor-pointer border-top border-bottom border-gray_10 {getMenuClass(item)}" if="{item.is_select}" onclick="{item.event}"> <div class="ts-ps word-break-all line-clamp-1 hover-text-blue_70">{item.label}</div><i class="icon-cheveron-down flex-fixed fs24 text-gray_30 hover-text-blue_70"></i> </div> </div> </div> </div> </div>', 'module-sidebar,[data-is="module-sidebar"]{display:block;z-index:1}', '', function(opts) {
    this.preload = async ({req, res}) => {
      if (spat.isNode) return;
      var companies = [];
      var company_id = req.params.company_id;
      var project_id = req.params.project_id;

      if (app.utils.auth.currentUser.role === 'operator') {
        var promises = [
          app.api.child('companies').get({limit: 999, offset: 0}),
          app.api.child(`companies/${company_id}/projects`).get({limit: 999, offset: 0})
        ];
        var [{companies}, {projects}] = await Promise.all(promises);
      }

      else {
        var promises = [
          app.api.child('me/companies').get({limit: 999, offset: 0}),
          app.api.child(`me/companies/${company_id}/projects`).get({limit: 999, offset: 0}),
          app.api.child(`companies/${company_id}/users/${app.utils.auth.currentUser.id}`).get({}),
        ];
        var [{companies}, {projects}, {company_user}] = await Promise.all(promises);
        var company_role = company_user.role;
      }
      var company = companies.filter(c => c.id === company_id)[0];
      if (project_id && projects && projects.length) {
        var project = projects.filter(p => p.id === project_id)[0];
      }

      this.menus = {
        admin: {
          top: [
            {
              id: 'companies',
              label: 'ダッシュボード',
              pages: ['page-companies', 'page-admin-companies-single'],
              event: () => spat.router.push(`${this.getCurrentPath('/companies')}`),
            },
            {
              id: 'distribution_rules',
              label: '配布ルール一覧',
              pages:['page-admin-distribution-rules', 'page-admin-distribution-rules-single'],
              event: () => spat.router.push(`${this.getCurrentPath('/distribution-rules')}`),
            },
            {
              id: 'operators',
              label: 'オペレーター管理',
              pages: ['page-operators'],
              event: () => spat.router.push(`${this.getCurrentPath('/operators')}`),
            },
            {
              id: 'paypay_maintenance',
              label: 'PayPayメンテナンス',
              pages: ['page-admin-paypay_maintenances', 'page-admin-paypay_maintenances-single'],
              event: () => spat.router.push(`${this.getCurrentPath('/paypay_maintenances')}`),
            },
            {
              id: 'nttcs_maintenance',
              label: 'NTTCSメンテナンス',
              pages: ['page-admin-nttcs_maintenances', 'page-admin-nttcs_maintenances-single'],
              event: () => spat.router.push(`${this.getCurrentPath('/nttcs_maintenances')}`),
            },
          ],
          bottom: [
            {
              id: 'account',
              label: app.utils.auth.currentUser.name,
              event: (e) => this.onOpenActionSheet(e),
              show_role: app.utils.auth.currentUser.role === "operator",
            },
          ],
        },
        app: {
          top: [
            {
              id: 'projects',
              get label() { return project.name },
              event: (e) => this.openModalSelect('projects'),
              is_select: true,
            },
            {
              id: 'campaigns',
              label: 'ダッシュボード',
              pages: ['page-projects-single', 'page-campaigns-single'],
              event: () => spat.router.push(`${this.getCurrentPath('')}`),
            },
            {
              id: 'members',
              label: 'メンバー管理',
              pages: ['page-members'],
              event: () => spat.router.push(`${this.getCurrentPath('/members')}`),
              permission: 'project_admin',

            },
            {
              id: 'webhooks',
              label: 'Webhookテンプレート管理',
              pages: ['page-webhooks'],
              event: () => spat.router.push(`${this.getCurrentPath('/webhooks')}`),
            },
            {
              id: 'edit',
              label: 'プロジェクト設定',
              pages: ['page-projects-single-edit'],
              event: () => spat.router.push(`${this.getCurrentPath('/edit')}`),
              permission: 'project_admin',
            },
          ],
          bottom: [
            {
              id: 'company',
              get label() {return company.name},
              event: () => this.openModalSelect('companies'),
              is_select: true,
            },
            {
              id: 'campaigns',
              label: '会社管理',
              event: () => this.onGoCompaniesSingle(),
              permission: 'company_owner',
            },
            {
              id: 'members',
              label: '残高/入金管理',
              event: () => this.onGoDepositManagement(),
            },
            {
              id: 'buy_points',
              label: 'ポイント購入申請はこちら',
              event: () => this.onGoBuyPoints(),
            },
            {
              id: 'help_page',
              label: 'ヘルプページはこちら',
              event: () => this.onGoHelpPage(),
            },
            {
              id: 'account',
              label: app.utils.auth.currentUser.name,
              event: (e) => this.onOpenActionSheet(e),
              show_role: app.utils.auth.currentUser.role === "operator",
            },
          ],
        },
      };

      if (app.utils.auth.currentUser.role === 'client') {
        this.filterMenus(company_id, project_id);
      }

      return {
        companies,
        company,
        projects,
        project: project || undefined,
      };
    };

    this.getMenus = (key) => {
      this.mode = location.pathname.split('/')[1];
      var menus = this.menus[this.mode][key];

      if (this.isClientPage() && !this.project && key === 'top') {
        menus = [
          {
            id: 'projects',
            label : "プロジェクト未選択",
            event: () => this.openModalSelect('projects'),
            is_select: true,
          },
        ];
      }
      return menus;
    };

    this.shouldHighlight = (menu) => {
      if (!menu.pages) return false ;
      return menu.pages.some(v => v === spat.appTag.navTag.currentPageTag.opts.dataIs);
    };

    this.getMenuClass = (menu) => {
      return this.shouldHighlight(menu) ? "text-blue_70 bg-blue_05 border-left border-blue_70 bw2" : "text-gray_80 ml2";
    };

    this.shouldHighlightSetting = () => {
      return '/settings' === location.pathname;
    };

    this.getCurrentPath = (link) => {

      if (!this.isClientPage()) {
        return `/admin${link}`;
      }

      else {
        return `/app/companies/${this.company.id}/projects/${this.project.id}${link}`;
      }
    };

    this.isClientPage = () => {
      return location.pathname.split('/').includes('app');
    };

    this.onGoDepositManagement = () => {
      spat.router.push(`/app/companies/${this.company.id}/deposit_histories`);
    };

    this.onGoBuyPoints = () => {
      window.open(app.data.buy_points_url, '_blank');
    };

    this.onGoHelpPage = () => {
      window.open(app.data.help_page_url, '_blank');
    };

    this.onGoCompaniesSingle = () => {
      spat.router.push(`/app/companies/${this.company.id}`);
    };

    this.openModalSelect = (type) => {
      var is_projects = type === 'projects';
      var items = is_projects ? this.projects : this.companies;
      var type = is_projects ? 'projects' : 'companies';
      var label = is_projects ? 'プロジェクト' : '企業';
      var createButton = !!is_projects && app.utils.permission.has('company_owner', { company_id: this.company.id});

      var query = {
        items,
        label,
        createButton,
      };

      var modal = spat.modal.open('modal-select', query);

      modal.on('create', () => {
        spat.router.push(`/app/companies/${this.company.id}/projects/new/edit`);
      });

      modal.on('selectcell', ({ item }) => {
        if (is_projects) {
          link = `/app/companies/${this.company.id}/projects/${item.id}`;
          spat.router.push(link);
        }
        else {
          var link = `/app/companies/${item.id}/projects`;
          spat.router.push(link);
        }
      });
    };

    this.onOpenActionSheet = (e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon:'user-circle',
          label: "アカウント設定",
          action: () => { popup.close(); this.goAccountSetting(); },
        },
        {
          icon:'logout',
          label: "ログアウト",
          action: () => { popup.close(); this.signOut(); },
          alert: true,
        }
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetLeft: 8,
        position: 'right',
        opts: {
          options,
        }
      });
    };

    this.goAccountSetting = () => {
      var url = `/${app.utils.auth.currentUser.role === "client" ? "app" : "admin"}/settings`;
      spat.router.push(url);
    };

    this.signOut = async () => {
      var modal = await spat.modal.open('modal-confirm', { text: 'ログアウトしますか?' });
      var result = await modal.waitClose();
      if (!result) return;
      app.utils.removeLastSeenItem();
      await app.auth.signOut();
      spat.modal.alert('ログアウトしました');
    };

    this.filterMenus = (company_id, project_id) => {

      this.menus.app.top = this.menus.app.top.filter(menu => {
        if (!menu.permission) return true;

        return app.utils.permission.has(menu.permission, { company_id, project_id });
      });

      this.menus.app.bottom = this.menus.app.bottom.filter(menu => {
        if (!menu.permission) return true;

        return app.utils.permission.has(menu.permission, { company_id });
      });
    };
});